import { renderDrawerHeaderNavigation_unstable } from '@fluentui/react-drawer';

/**
 * Renders the final JSX of the DrawerHeaderNavigation component, given the state.
 */
export const renderDrawerHeaderNavigation = renderDrawerHeaderNavigation_unstable;
